import { formatDisplayName } from '../p2p/displayName.js';

const GAME_ID_RE = /^[a-zA-Z0-9-]{1,64}$/;
const PEER_ID_RE = /^dc-[a-f0-9]{16}-[a-f0-9]{10}$/i;
const PLAYER_ID_RE = /^dc-[a-f0-9]{16}$/i;
const GAME_ROLE_RE = /^(host|join|spectator)$/;

export const MAX_RESUME_CHECKPOINT_ENCODED_LENGTH = 8192;

export function parseGameId(value) {
  const normalized = String(value || '').trim();
  return GAME_ID_RE.test(normalized) ? normalized : null;
}

export function parsePeerId(value) {
  const normalized = String(value || '').trim();
  return PEER_ID_RE.test(normalized) ? normalized : null;
}

export function parseGameRole(value) {
  const normalized = String(value || '').trim().toLowerCase();
  if (!normalized) {
    return 'join';
  }
  return GAME_ROLE_RE.test(normalized) ? normalized : 'join';
}

export function playerIdFromPeerId(peerId) {
  const match = String(peerId || '').match(/^dc-[a-f0-9]{16}/i);
  return match ? match[0].toLowerCase() : null;
}

export function isPlayerIdBoundToPeer(playerId, peerId) {
  const derived = playerIdFromPeerId(peerId);
  if (!derived || !playerId) {
    return false;
  }
  return derived === String(playerId).toLowerCase();
}

export function isValidPlayerId(value) {
  return PLAYER_ID_RE.test(String(value || ''));
}

export function trustedHelloNickname(message) {
  const derivedPlayerId = playerIdFromPeerId(message.senderId);
  const claimedPlayerId = message.payload?.playerId;
  if (claimedPlayerId && !isPlayerIdBoundToPeer(claimedPlayerId, message.senderId)) {
    return derivedPlayerId
      ? formatDisplayName('Player', derivedPlayerId)
      : message.senderId;
  }
  const playerId = claimedPlayerId || derivedPlayerId;
  const nickname = message.payload?.nickname || 'Player';
  return playerId ? formatDisplayName(nickname, playerId) : nickname;
}

export function trustedPeerNickname(peer) {
  const derivedPlayerId = playerIdFromPeerId(peer.peerId);
  const claimedPlayerId = peer.metadata?.playerId;
  if (claimedPlayerId && !isPlayerIdBoundToPeer(claimedPlayerId, peer.peerId)) {
    return derivedPlayerId
      ? formatDisplayName('Player', derivedPlayerId)
      : peer.peerId;
  }
  const playerId = claimedPlayerId || derivedPlayerId;
  const nickname = peer.metadata?.nickname || 'Player';
  return playerId ? formatDisplayName(nickname, playerId) : nickname;
}
